import { TextEditor } from 'shared/ui/TextEditor';

import { DefaultTodoItemWrapper } from './styled';

export const DefaultTodoItem = ({ title }: { title: string }) => (
  <DefaultTodoItemWrapper>
    <TextEditor
      value={title}
      backgroundColor='none'
      border='none'
      minHeight='0'
      readonly
      withoutToolbar
      padding='3px'
      borderTop='0'
    />
  </DefaultTodoItemWrapper>
);
